import React from "react";
import { connect } from "react-redux";
import styled, { css } from "styled-components";
import { IconButton, MenuItem, Menu } from "@material-ui/core";
import {
    Add as AddIcon,
    ArrowBack as BackIcon,
    ArrowForward as ForwardIcon,
    Menu as MenuIcon
} from "@material-ui/icons";
import { hot } from "react-hot-loader";
import {
    setWeekCount,
    incrementWeekStart,
    decrementWeekStart,
    addEventRow
} from "./actions";
import { selectWeekCount, selectTemplate } from "./selectors";

const StyledIconButton = styled(IconButton)`
    grid-column-start: ${props => props.column};
    grid-column-end: ${props => props.column};
    max-width: 20px;
    max-height: 20px;
    color: white;
`;

const IconStyles = css`
    max-width: 18px;
    max-height: 18px;
    color: white;
`;

const StyledAddIcon = styled(AddIcon)`
    ${IconStyles}
`;

const StyledBackIcon = styled(BackIcon)`
    ${IconStyles}
`;

const StyledForwardIcon = styled(ForwardIcon)`
    ${IconStyles}
`;

const ControlCellContainer = styled.div`
    grid-template-rows: 1fr;
    grid-template-columns: 0.5fr 2fr 0.5fr 0.6fr 0.4fr;
    grid-row-start: 1;
    grid-row-end: 1;
    grid-column-start: 1;
    grid-column-end: 1;
    display: grid;
    padding-top: 6px;
`;
const StyledMenuItem = styled(MenuItem)`
    max-height: 10px;
`;

const HeaderIcon = styled(MenuIcon)`
    max-width: 16px;
    max-height: 16px;
    color: white;
`;
// const Select = styled.select`
//     border: none;
//     height: 19px;
//     border-radius: 2px;
//     font-size: 12px;
//     appearance: none;
//     text-align: center;
//     text-align-last: center;
//     margin-left: 4px;
//     margin-right: 4px;
// `;

class DayCell extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            anchorEl: null,
            editRowCellModalOpen: false,
            confirmDeleteModalOpen: false
        };
    }
    handleClose = () => {
        this.setState({ anchorEl: null });
    };
    handleClick = event => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleChange = event => {
        this.props.setWeekCount(event.target.value);
    };
    render() {
        return (
            <ControlCellContainer>
                <StyledIconButton
                    variant="extended"
                    column={1}
                    onClick={this.props.addEventRow}
                >
                    <StyledAddIcon />
                </StyledIconButton>
                {/* <Select onChange={this.handleChange} value={this.props.weekCount}>
                    <option value={1}>1 Week</option>
                    <option value={2}>2 Weeks</option>
                </Select> */}
                <StyledIconButton
                    variant="extended"
                    column={3}
                    onClick={this.props.decrementWeekStart}
                >
                    <StyledBackIcon />
                </StyledIconButton>
                <StyledIconButton
                    variant="extended"
                    column={4}
                    onClick={this.props.incrementWeekStart}
                >
                    <StyledForwardIcon />
                </StyledIconButton>
                <StyledIconButton
                    color="primary"
                    column={5}
                    aria-owns={this.state.anchorEl ? "simple-menu" : undefined}
                    aria-haspopup="true"
                    onClick={this.handleClick}
                >
                    <HeaderIcon />
                </StyledIconButton>
                <Menu
                    id="simple-menu"
                    anchorEl={this.state.anchorEl}
                    open={Boolean(this.state.anchorEl)}
                    onClose={this.handleClose}
                >
                    <StyledMenuItem
                        onClick={() => {
                            this.props.setSetTemplateModalOpen();
                            this.handleClose();
                        }}
                    >
                        Set Template
                    </StyledMenuItem>
                    {this.props.template !== false && (
                        <StyledMenuItem
                            onClick={() => {
                                this.props.setApplyTemplateModalOpen();
                                this.handleClose();
                            }}
                        >
                            Apply Template
                        </StyledMenuItem>
                    )}
                </Menu>
            </ControlCellContainer>
        );
    }
}

export default hot(module)(
    connect(
        store => {
            return {
                weekCount: selectWeekCount(store),
                template: selectTemplate(store)
            };
        },
        { setWeekCount, incrementWeekStart, decrementWeekStart, addEventRow }
    )(DayCell)
);
